import React from "react"

function Testing(){

return (

    <h1>testing </h1>
)

}

export default Testing
